import axios from "axios";

export const getSwitzerlandData = async (query) => {
  const params = {
    keyword: query,
  };
  try {
    let data = await axios.get(
      `${process.env.REACT_APP_COMPANY_LOOKUP_BASE_URL}/searchSwitzerlandCompany`,
      {
        params,
      }
    );
    data = data?.data;
    if (!data.length) return [];

    if (data === "No Search result found") return [];
    const finalData = [];
    for (const item of data) {
      const { name, uid, status } = item;
      const obj = {
        companyName: name,
        companyNumber: uid,
        companyStatus: status,
      };
      finalData.push(obj);
    }
    return finalData;
  } catch (error) {
    return error;
  }
};
